import { ShiftMaintenanceConstant } from "presentation/constant/Shift/ShiftMaintenanceConstant";
import { useShiftMaintenanceVM } from "presentation/hook/Shift/useShiftMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useShiftMaintenanceTracked } from "presentation/store/Shift/ShiftMaintenanceProvider";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import { memo, useCallback, useState } from "react";
import { HPHBreadcrumb, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
const ShiftEditPanelTitleBar: React.FC = () => {
    const [shiftState] = useShiftMaintenanceTracked();
    const shiftVM = useShiftMaintenanceVM();
    const messageBarVM = useMessageBarVM();
    const { currentSelectedRow, masterState } = shiftState;
    const { editingEntity, isAdd, isEditable } = masterState;
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;

    const [isLoading, setIsLoading] = useState(false);
    const currentEntity = (isAdd || isEditable) ? editingEntity : currentSelectedRow;
    const handleReset = useCallback(async () => {
        shiftVM.onReset();
    }, [shiftVM]);
    const handleEdit = useCallback(() => {
        shiftVM.onEditClick(currentEntity);
    }, [currentEntity, shiftVM])
    const handleSave = useCallback(async () => {
        setIsLoading(true);
        try {
            shiftVM.onSaveClicked();
            const res = await shiftVM.onSave(currentEntity, isAdd);
            if (!!!res || !res.success) {
                res?.data && messageBarVM.showError(res?.data ?? 'Save data failed.');
            } else {
                messageBarVM.showSuccess("Save Successfully.");
                shiftVM.onClose();
                setIsLoading(true);
            }
        } catch (error) {
            messageBarVM.showError('Save data failed.');
        } finally {
            setIsLoading(false)
        }

    }, [currentEntity, isAdd, messageBarVM, shiftVM]);
    return <Sidebarheader style={{ width: '100%' }}>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        <Breadcrumb>
            <HPHBreadcrumb breadcrumbData={[{ title: ShiftMaintenanceConstant.SCREEN_CATEGORY },
            { title: ShiftMaintenanceConstant.TITLE }]} onCurrentClick={() => { }}>
            </HPHBreadcrumb>
        </Breadcrumb>
        <StyledAction>
            {allowUpdate && (!(isAdd || isEditable)) && <NbisIconButton fileName='Icon-pen' size='medium' toolTipText={'Edit'} toolTipArrow={false} onClick={handleEdit} disabled={false} />}
            {(isAdd || isEditable) && <IconButton fileName="Icon-reset" size="medium" toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={handleReset} />}
            {<IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="left" toolTipText={'Close'} onClick={shiftVM.onClose} />}
            {(isAdd || isEditable) && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
        </StyledAction>
    </Sidebarheader>
}
export default memo(ShiftEditPanelTitleBar); 
